import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';
import ValueExpression, {
  TargetValueType,
} from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';

export default new ValueExpression({
  identifier: 'zustellungen_pro_einwohner',
  label: 'Zustellungen pro Einwohner',
  positiveDirection: PositiveDirection.custom,
  targetValueType: TargetValueType.QUOTE,
  decimalPlaces: 2,
});
